import { useEffect, useRef } from 'react';

import { FieldValues } from 'react-hook-form';

import { IUseScrollToFormErrorOptions } from './types';

export const useScrollToFormError = <TFieldValues extends FieldValues>({
  errors,
  block = 'center',
  shouldFocus = true,
}: IUseScrollToFormErrorOptions<TFieldValues>) => {
  const fieldsWrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (
      !errors ||
      Object.keys(errors).length === 0 ||
      !fieldsWrapperRef.current
    )
      return;

    const hasError = (fieldName: string): boolean => {
      const parts = fieldName.split('.');
      let current: unknown = errors;

      for (const part of parts) {
        if (!current || typeof current !== 'object') return false;
        current = (current as Record<string, unknown>)[part];
      }

      return Boolean(current);
    };

    const rafId = requestAnimationFrame(() => {
      if (!fieldsWrapperRef.current) return;
      const allFormItems =
        fieldsWrapperRef.current.querySelectorAll<HTMLElement>(
          '[data-field-name]',
        );
      for (const el of allFormItems) {
        const name = el.getAttribute('data-field-name');
        if (name && hasError(name)) {
          el.scrollIntoView({
            behavior: 'smooth',
            block,
          });
          break;
        }
      }
    });

    return () => {
      cancelAnimationFrame(rafId);
    };
  }, [errors, block, shouldFocus]);
  return fieldsWrapperRef;
};
